/**
 * AvailableWinData.ts
 */
export class AvailableWinData {
    constructor(key, numberOfPatterns, cells, winAmount) {
        this.key = key;
        this.numberOfPatterns = numberOfPatterns;
        this.cells = cells;
        this.numberOfCells = cells.length;
        this.winAmount = winAmount;
    }
    getKey() {
        return this.key;
    }
    getNumberOfPatterns() {
        return this.numberOfPatterns;
    }
    getCells() {
        return this.cells;
    }
    getNumberOfCells() {
        return this.numberOfCells;
    }
    getWinAmount() {
        return this.winAmount;
    }
}
//# sourceMappingURL=AvailableWinData.js.map